import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constant/Constant';
import restClient from '../../MainFrame/action/APIClient';
import LogoutConstant from '../../MainFrame/constants/Constants';

var DeleteCustomNavigationAction = function () {

}


DeleteCustomNavigationAction.prototype = {

	delete: function (domanName, tabId) {
		restClient.deleteCustomNavigationLinks(domanName, tabId, function (error, response) {
			if (error) {
				AppDispatcher.dispatch({
					actionType: Constant.DELETE_CUSTOM_NAV,
					data: error
				});
			} else {
				response.status = 200;
				AppDispatcher.dispatch({
					actionType: Constant.DELETE_CUSTOM_NAV,
					data: response
				});
			}
		})
	}
}


export default new DeleteCustomNavigationAction();